import type { CSS } from '@grupoboticario/flora-react'

export const tagCss: CSS = {
  fontWeight: '$bold'
}
